// Scroll to the inquiry form and preselect a service via a window event.
export const requestService = (serviceValue) => {
  const el = document.querySelector("#kontakt");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  if (serviceValue) {
    window.dispatchEvent(new CustomEvent("preselect-service", { detail: serviceValue }));
  }
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
